import { useAtom } from "jotai";
import { Select } from "src/elements";
import { localeAtom } from "../store/atoms";
import type { Locale } from "../store/types";
import { useTranslation } from "../hooks/UseTranslation";

const localeOptions: { value: Locale; label: string }[] = [
  { value: "en", label: "English" },
  { value: "es", label: "Español" },
];

export const LanguageSwitcher = () => {
  const [locale, setLocale] = useAtom(localeAtom);
  const { t } = useTranslation("common");

  return (
    <Select
      options={localeOptions}
      value={locale}
      setValue={(value) => setLocale(value)}
      title={t("language")}
      width="200px"
    />
  );
};
